import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-col items-center gap-6" data-id="element-179">
      <div className="flex items-center gap-6 flex-wrap justify-center opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-180">
        {/* Mercado Pago */}
        <img src="https://cdn.magicpatterns.com/uploads/5anDiPc7wgfSmYDiMpdcR8/Captura_de_pantalla_29-3-2026_23105_www.mercadopago.com.mx.jpg" alt="Mercado Pago" className="w-8 h-8 object-contain rounded-sm" data-id="element-181" />

        {/* Visa */}
        <svg viewBox="0 0 40 24" className="w-10 h-6" fill="none" data-id="element-182">
          <rect width="40" height="24" rx="2" fill="#1A1F71" data-id="element-183" />
          <path d="M17.2 8.2l-2.6 7.6h-2.1l-1.3-6c-.1-.3-.2-.5-.5-.6-.5-.3-1.3-.5-2-.7l.1-.3h3.3c.4 0 .8.3.9.8l.8 4.4 2.1-5.2h2.1zm8.3 5.1c0-2-2.8-2.1-2.8-3 0-.3.3-.5.7-.6.6 0 1.2.1 1.7.3l.3-1.5c-.5-.2-1.2-.4-2-.4-2.1 0-3.5 1.1-3.5 2.6 0 1.2 1 1.8 1.8 2.2.8.4 1 .6 1 1 0 .5-.6.8-1.2.8-.7 0-1.4-.2-1.8-.4l-.3 1.5c.6.2 1.3.3 2.1.3 2.2 0 3.6-1.1 3.6-2.7zm5.5 2.5h1.8l-1.6-7.6h-1.7c-.4 0-.7.2-.8.5l-3 7.1h2.1l.4-1.1h2.5l.3 1.1zm-2.2-2.7l1-2.9.6 2.9h-1.6zm-8.3-4.9l-1.6 7.6h-2l1.6-7.6h2z" fill="white" data-id="element-184" />
        </svg>

        {/* Mastercard */}
        <svg viewBox="0 0 40 24" className="w-10 h-6" fill="none" data-id="element-185">
          <rect width="40" height="24" rx="2" fill="#000" data-id="element-186" />
          <circle cx="16" cy="12" r="7" fill="#EB001B" data-id="element-187" />
          <circle cx="24" cy="12" r="7" fill="#F79E1B" data-id="element-188" />
          <path d="M20 6.8a7 7 0 000 10.4 7 7 0 000-10.4z" fill="#FF5F00" data-id="element-189" />
        </svg>

        {/* Satisfaction Badge */}
        <div className="flex items-center gap-1.5 border-l border-white/10 pl-6" data-id="element-190">
          <ShieldCheck className="w-4 h-4 text-gold" strokeWidth={1} data-id="element-191" />
          <span className="text-[9px] text-gray-400 font-sans tracking-[0.1em] uppercase" data-id="element-192">
            Acceso Seguro
          </span>
        </div>
      </div>

      <p className="text-[10px] text-gray-600 font-sans tracking-[0.1em] uppercase text-center" data-id="element-193">
        Pago 100% seguro en pesos argentinos.
      </p>
    </div>;
}